module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container full-width"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('app-header'), _vm._v(" "), _c('side-info', {
    ref: "sideInfo",
    style: ([_vm.mainPaddingTop]),
    attrs: {
      "template": _vm.name
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "main",
    style: (_vm.mainPaddingTop)
  }, [_c('div', {
    staticClass: "fil-ariane"
  }, [_c('router-link', {
    staticClass: "parent-items",
    attrs: {
      "to": "/app/home"
    }
  }, [_vm._v("\n          Mon espace >\n        ")]), _vm._v(" "), _c('router-link', {
    staticClass: "parent-items",
    attrs: {
      "to": "/app/creer-un-message"
    }
  }, [_vm._v("\n          Ajouter un nouveau message >\n        ")]), _vm._v(" "), _c('router-link', {
    staticClass: "parent-items",
    attrs: {
      "to": "/app/gerer-diffusion"
    }
  }, [_vm._v("\n          Gérer ma diffusion\n        ")])], 1), _vm._v(" "), _c('h1', {
    staticClass: "page-title"
  }, [_vm._v("Choisir mon message")]), _vm._v(" "), _c('div', {
    style: (_vm.welcomeMessages['noCreationOnDisplay'])
  }, [_c('p', {
    staticStyle: {
      "margin-top": "calc(100vh / (949 / 10))",
      "font-family": "'Open Sans', Arial",
      "font-size": "14px"
    }
  }, [_vm._v("\n        Vous n'avez aucun message en cours. Consultez "), _c('router-link', {
    staticStyle: {
      "color": "var(--primary-color)"
    },
    attrs: {
      "to": "/miscellanous/mentions-legales"
    }
  }, [_vm._v("les mentions légales")]), _vm._v(" avant de diffuser votre message promotionnel ou informatif.\n      ")], 1)]), _vm._v(" "), _c('div', {
    staticClass: "main-content"
  }, [_c('div', {
    staticClass: "info-box-main"
  }, [_c('svg', {
    staticClass: "info-box-icon-main",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "8949 -947 14.89 50"
    }
  }, [_c('path', {
    staticClass: "a",
    attrs: {
      "d": "M30.19,997.365a2.5,2.5,0,1,0,2.5,2.5A2.5,2.5,0,0,0,30.19,997.365Zm0,16.541H22.56l.012,3,5.89-.021v27.5H22.556l.006,2.952,7.628.01,7.255.018-.006-2.97-5.519-.01v-27.5c0-2.991.046-2.987-1.73-2.987Z",
      "transform": "translate(8926.444 -1944.365)"
    }
  })]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "table-display"
  }, [(_vm.userProps && _vm.userProps.appData && _vm.userProps.appData.medias && _vm.userProps.appData.medias.length !== 0) ? _c('div', {
    staticClass: "strip-wrapper"
  }, [_c('div', {
    staticClass: "table-cell v-align-middle",
    style: (_vm.arrowLeft),
    attrs: {
      "id": "arrow-left"
    },
    on: {
      "click": _vm.toTheRight
    }
  }, [_c('svg', {
    staticClass: "black-arrow",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "10687 441.84 26.286 50"
    }
  }, [_c('path', {
    staticClass: "a",
    attrs: {
      "d": "M43.143,6.285a.945.945,0,0,1-.279.67L19.811,30.009,42.85,53.046a.947.947,0,0,1,0,1.342l-.336.334a.945.945,0,0,1-1.34,0L17.133,30.68a.939.939,0,0,1-.2-1.045.974.974,0,0,1,.1-.148.908.908,0,0,1,.1-.146l0,0c.005-.005.007-.012.012-.018L41.188,5.279a.947.947,0,0,1,1.342,0l.334.334a.949.949,0,0,1,.279.672Z",
      "transform": "translate(10670.143 436.84)"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "table-cell media-library-holder"
  }, [_c('div', {
    staticClass: "strip-holder"
  }, [_c('div', {
    staticClass: "strip",
    style: (_vm.stripLeft)
  }, _vm._l((_vm.userProps.appData.medias), function(media, index) {
    return (typeof media.media_content.diffusionIndex !== 'number') ? _c('div', {
      staticClass: "vignette-holder",
      on: {
        "mouseenter": function($event) {
          $event.preventDefault();
          return _vm.showVignetteTooltip(media.media_id)
        },
        "mouseleave": function($event) {
          $event.preventDefault();
          return _vm.hideVignetteTooltip(media.media_id)
        }
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.tooltipVignette[media.media_id]),
        expression: "tooltipVignette[media.media_id]"
      }],
      staticClass: "bmtv-tooltip-inner bmtv-tooltip-vignette"
    }, [_c('div', {
      staticClass: "bmtv-tooltip-inner-item",
      on: {
        "click": function($event) {
          return _vm.zoom(media.media_id)
        }
      }
    }, [_vm._v("\n                          Zoomer\n                          "), _c('div', {
      staticClass: "glyphicon glyphicon-zoom-in context-ico"
    })]), _vm._v(" "), _c('div', {
      staticClass: "bmtv-tooltip-inner-item",
      on: {
        "click": function($event) {
          return _vm.reuse(media.media_id)
        }
      }
    }, [_vm._v("\n                          Réutiliser\n                          "), _c('div', {
      staticClass: "glyphicon glyphicon-retweet context-ico"
    })]), _vm._v(" "), _c('div', {
      staticClass: "bmtv-tooltip-inner-item",
      attrs: {
        "data-media-id": media.media_id
      },
      on: {
        "click": function($event) {
          return _vm.suppress(media.media_id)
        }
      }
    }, [_c('input', {
      attrs: {
        "type": "hidden",
        "id": "mediaIdSuppression",
        "name": "mediaIdSuppression"
      }
    }), _vm._v("\n                          Supprimer\n                          "), _c('div', {
      staticClass: "glyphicon glyphicon-trash context-ico"
    })]), _vm._v(" "), _c('div', {
      staticClass: "bmtv-tooltip-arrow"
    })]), _vm._v(" "), _c('div', {
      staticClass: "vignette-diffusion has-tooltip",
      style: ({
        backgroundImage: 'url(' + media.media_content.message + ')',
        backgroundSize: 'cover'
      }),
      attrs: {
        "id": 'strip-' + media.media_id,
        "draggable": "true"
      },
      on: {
        "dragstart": _vm.dragStart,
        "dragend": _vm.dragEnd
      }
    })]) : _vm._e()
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "table-cell v-align-middle",
    style: (_vm.arrowRight),
    attrs: {
      "id": "arrow-right"
    },
    on: {
      "click": _vm.toTheLeft
    }
  }, [_c('svg', {
    staticClass: "black-arrow",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "11589.272 441.84 26.291 50"
    }
  }, [_c('path', {
    staticClass: "a",
    attrs: {
      "d": "M16.858,6.285a.945.945,0,0,0,.279.67L40.195,30.009,17.151,53.046a.947.947,0,0,0,0,1.342l.336.334a.945.945,0,0,0,1.34,0L42.873,30.68a.939.939,0,0,0,.2-1.045.974.974,0,0,0-.1-.148.908.908,0,0,0-.1-.146l0,0c-.005-.005-.006-.012-.012-.018L18.813,5.279a.947.947,0,0,0-1.342,0l-.334.334a.949.949,0,0,0-.279.672Z",
      "transform": "translate(11572.415 436.84)"
    }
  })])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "visualisation-holder"
    }
  }, [_c('div', {
    style: (_vm.welcomeMessages['noCreationYetDisplay']),
    attrs: {
      "id": "no-creation-yet"
    }
  }, [_c('p', {
    staticStyle: {
      "margin-bottom": "calc(100vh / (949 / 40))"
    }
  }, [_vm._v("\n            Vous vous connectez pour la première fois ?"), _c('br'), _vm._v("Consultez "), _c('router-link', {
    attrs: {
      "to": "/miscellanous/conseils-pratiques"
    }
  }, [_vm._v("nos conseils pratiques")]), _vm._v(" avant de créer votre premier message promotionnel ou informatif.\n          ")], 1), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-default btn-side-info",
    staticStyle: {
      "margin-top": "calc(100vw / (1920 / 40))"
    },
    attrs: {
      "to": "/app/creer-un-message",
      "id": "mentions-legales"
    }
  }, [_vm._v("\n            CRÉER MON PREMIER MESSAGE\n          ")])], 1), _vm._v(" "), _c('div', {
    style: (_vm.welcomeMessages['noCreationOnDisplay']),
    attrs: {
      "id": "no-creation-on"
    }
  }, [_c('current-diffusion', {
    attrs: {
      "slotLimit": _vm.slotLimit,
      "editEnabled": _vm.editEnabled,
      "userProps": _vm.userProps,
      "overDropZone": _vm.overDropZone,
      "terminalMediaArr": _vm.terminalMediaArr,
      "currentDraggedImg": _vm.currentDraggedImg
    }
  })], 1), _vm._v(" "), _c('div', {
    style: (_vm.welcomeMessages['currentCreationsDisplay']),
    attrs: {
      "id": "current-creations"
    }
  }, [_c('current-diffusion', {
    attrs: {
      "slotLimit": _vm.slotLimit,
      "editEnabled": _vm.editEnabled,
      "userProps": _vm.userProps,
      "overDropZone": _vm.overDropZone,
      "terminalMediaArr": _vm.terminalMediaArr,
      "currentDraggedImg": _vm.currentDraggedImg
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "hr"
  })])]), _vm._v(" "), _c('app-footer'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-lg",
    staticStyle: {
      "visibility": "hidden"
    },
    attrs: {
      "id": "modalButton",
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#confirmationModal"
    }
  }, [_vm._v("\n    Launch modal\n  ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-lg",
    staticStyle: {
      "visibility": "hidden"
    },
    attrs: {
      "id": "modal2Button",
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#validModal"
    }
  }, [_vm._v("\n    Launch modal\n  ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "visibility": "hidden"
    },
    attrs: {
      "id": "tempHolder"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "confirmationModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-title",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "arrow",
    staticStyle: {
      "margin-left": "0"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "h2-arrow",
    staticStyle: {
      "padding": "0"
    }
  }, [_vm._v("\n                SOUHAITEZ-VOUS CONFIRMER"), _c('br'), _vm._v("LA SUPPRESSION DE CE MEDIA\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "id": "messageSuppressionConfirmed"
    }
  }, [_vm._v("Ok")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "validModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-title",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "arrow",
    staticStyle: {
      "margin-left": "0"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "h2-arrow",
    staticStyle: {
      "padding": "0"
    },
    attrs: {
      "id": "validModalContent"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Ok")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-text-main"
  }, [_vm._v("\n          Déplacez vos messages vers la caisse sur laquelle"), _c('br'), _vm._v("vous souhaitez diffuser l'annonce.\n        ")])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-695849e0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-695849e0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/GererDiffusion.vue
// module id = 197
// module chunks = 1